/**
 * An external (PACE Online) user's FrontId does not start with 'Z'. Shared by the selector below
 * and by `UserMasterEffects`, which has to apply the same rule to a not-yet-selected candidate.
 *
 * @param frontId the user's front id
 */
export const isPaceOnlineUserFrontId = (frontId: string | undefined): boolean => !(frontId && frontId[0] === 'Z');
